module.exports = __webpack_public_path__ + "img/car_00036.543596c9.jpg";